/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
const blocks = document.querySelectorAll(".wp-block-wordpress-theme-boilerplate-link-block");

const copyAttributes = (from, to) => {
    [...from.attributes].forEach((attribute) => {
        const { name, value } = attribute;

        if (name === "href" || name === "target" || name === "rel") {
            return;
        }

        to.setAttribute(name, value);
    });
};

blocks.forEach((block) => {
    const shouldUsePostLink = block.dataset.usePostLink === "true";

    if (shouldUsePostLink && block.tagName === "A") {
        const post = block.closest(".wp-block-post");
        let postLink = null;

        if (post) {
            const postTitleLink = post.querySelector(".wp-block-post-title a");
            postLink = postTitleLink?.getAttribute("href") || null;
        }

        if (postLink) {
            block.setAttribute("href", postLink);
        }
    }

    const innerLinks = block.querySelectorAll(".link-block__inner a");

    innerLinks.forEach((link) => {
        const span = document.createElement("span");
        copyAttributes(link, span);
        span.innerHTML = link.innerHTML;
        link.replaceWith(span);
    });
});
